import * as React from 'react';
import { connect } from 'react-redux';

import IState from '../../interfaces/states';

import {
    Modal as ModalAction,
} from '../../actions';

import OpenModalContainer from './OpenModalContainer';

interface IProps {
    activeModal: string,
    close: Function,
}

class ModalContainer extends React.Component<IProps, void> {
    static propTypes = {
        activeModal: React.PropTypes.string,
        close: React.PropTypes.func.isRequired,
    };

    onClose() {
        this.props.close();
    }

    render() {
        return (
            <OpenModalContainer
                activeModal={this.props.activeModal}
                onClose={() => this.onClose()}
            />
        );
    }
}

const mapStateToProps = (state: IState) => ({
    activeModal: state.modal.activeModal
});

export default connect(
    mapStateToProps,
    {
        close: ModalAction.close
    }
)(ModalContainer);


// WEBPACK FOOTER //
// ./src/components/modal/ModalContainer.tsx